module.exports = __webpack_public_path__ + "img/murmann.4f84ccf3.png";